import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { NgClass, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SwitchComponent,
      multi: true,
    },
  ],
  imports: [NgClass, NgIf, TranslatePipe],
})
export class SwitchComponent implements ControlValueAccessor {
  @Output() change = new EventEmitter<boolean>();
  @Input() click: ($event) => Observable<boolean>;
  @Input() showLabels: boolean = true;
  @Input() highlightActiveLabel = false;
  @Input() defaultValue?: boolean;

  disabled = false;
  isChecked = false;
  onChange = (_) => {};
  onBlur = (_) => {};

  writeValue(obj: boolean): void {
    this.isChecked = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onBlur = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChanged($event) {
    this.isChecked = $event && $event.target && $event.target.checked;
    this.onChange(this.isChecked);
  }

  onClick($event: any) {
    if (this.disabled) return;
    if (this.click) {
      $event.preventDefault();
      this.click($event).subscribe((ok) => {
        if (ok) {
          this.isChecked = !(this.isChecked ?? this.defaultValue);
        }
      });
    } else {
      this.isChecked = !(this.isChecked ?? this.defaultValue);
      this.onChange(this.isChecked);
      this.change.emit(this.isChecked);
    }
  }
}
